import { darkenHex, hexToRgb, mixHex, normalizeHex } from '@theme/colorUtils'

export type DerivedAccentPalette = {
  navItemActiveBg: string
  navItemActiveBgHover: string
  menuPanelBg: string
  tableHeadBg: string
  tableHeadBorder: string
  tableHeadText: string
  tableWrapperBorder: string
  rowHoverBg: string
  rowSelectedBg: string
  rowSelectedHoverBg: string
  tableLevel2HeadBg: string
  tableLevel2HeadBorder: string
}

function relativeLuminance(hex: string): number {
  const rgb = hexToRgb(hex)
  if (!rgb) return 0.5
  const toLin = (c: number) => {
    const s = c / 255
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
  }
  return 0.2126 * toLin(rgb.r) + 0.7152 * toLin(rgb.g) + 0.0722 * toLin(rgb.b)
}

/**
 * Menu active tối hơn header ~19%. Header bảng pha trắng ít hơn để nền đậm hơn.
 */
export function deriveAccentFromMain(mainRaw: string): DerivedAccentPalette {
  const main = normalizeHex(mainRaw)
  const darkAccent = relativeLuminance(main) < 0.28
  const navItemActiveBg = darkenHex(main, 0.19)
  const navItemActiveBgHover = darkenHex(main, 0.26)

  return {
    navItemActiveBg,
    navItemActiveBgHover,
    menuPanelBg: navItemActiveBg,
    tableHeadBg: mixHex(main, '#ffffff', darkAccent ? 0.62 : 0.7),
    tableHeadBorder: mixHex(main, '#e2e8f0', darkAccent ? 0.55 : 0.62),
    tableHeadText: '#15171a',
    tableWrapperBorder: mixHex(main, '#eaedf1', 0.88),
    rowHoverBg: mixHex(main, '#ffffff', darkAccent ? 0.93 : 0.955),
    rowSelectedBg: mixHex(main, '#ffffff', darkAccent ? 0.82 : 0.86),
    rowSelectedHoverBg: mixHex(main, '#ffffff', darkAccent ? 0.74 : 0.78),
    tableLevel2HeadBg: mixHex(main, '#ffffff', darkAccent ? 0.94 : 0.96),
    tableLevel2HeadBorder: mixHex(main, '#dbeafe', darkAccent ? 0.42 : 0.48),
  }
}
